import { Order } from '../../api/api-generated';
import { stringIncludesIgnoreCase } from '../../utils/comparisons';
import { truncateISOString } from '../../utils/dateTime';
import { OrderItemFilter } from './ordersTypes';

export const orderFilterConstraintChecker = (
  name: string,
  value: string,
  filters: OrderItemFilter
) => {
  if (name === 'orderDateFrom') {
    if (filters.orderDateTo && filters.orderDateTo < value) return false;
  }
  if (name === 'orderDateTo') {
    if (filters.orderDateFrom && filters.orderDateFrom > value) return false;
  }
  return true;
};

export const ordersMiddlware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel === 'company') return { company: autoboxValue };
  return {};
};

export const orderValidator = (item: any) => {
  if (!item.company) return false;
  if (!item.orderDate) return false;
  if (!item.price) return false;
  return true;
};

export const filterOrder = (item: Order, filters: OrderItemFilter): boolean => {
  if (
    filters.company &&
    !stringIncludesIgnoreCase(
      item.company.companyName,
      filters.company.companyName
    )
  )
    return false;
  if (
    filters.purchaseOrderName &&
    !stringIncludesIgnoreCase(item.purchaseOrderName, filters.purchaseOrderName)
  )
    return false;
  if (
    filters.orderDateFrom &&
    (item.orderDate === null ||
      truncateISOString(item.orderDate) <
        truncateISOString(filters.orderDateFrom))
  )
    return false;
  if (
    filters.orderDateTo &&
    (item.orderDate === null ||
      truncateISOString(item.orderDate) >
        truncateISOString(filters.orderDateTo))
  )
    return false;
  return true;
};
